"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrentDate = exports.getDaysInMonth = exports.getLocaleFormatString = exports.getLocaleDateFormat = void 0;

var _react = require("react");

var _types = require("./date-parts/types");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Uses a known date and the built in DateTimeFormat to return the local format for a date string.
 * e.g. 'en-GB' would return 'date/month/year'
 *
 * @param placeholder - The placeholder character to use to generate placeholder string. Default = '_'.
 * @param [locale] A string with a BCP 47 language tag, or an array of such strings. To use the browser's default locale, omit this argument or pass undefined.
 *
 * [mdn-dtf]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 */
var getLocaleDateFormat = function getLocaleDateFormat(placeholder, locale) {
  var intlFormatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  var knownYear = 1999;
  var knownMonth = 10;
  var knownDay = 15;
  var partsString = intlFormatter.format(new Date(knownYear, knownMonth, knownDay, 12)).replace("".concat(knownDay), _types.DatePartEnum.DATE).replace("".concat(knownMonth + 1), _types.DatePartEnum.MONTH).replace("".concat(knownYear), _types.DatePartEnum.YEAR);
  var separator = partsString.replace(new RegExp("".concat(_types.DatePartEnum.DATE, "|").concat(_types.DatePartEnum.MONTH, "|").concat(_types.DatePartEnum.YEAR), 'g'), '')[0];
  var order = partsString.split(separator).reduce(function (acc, part) {
    if (part === _types.DatePartEnum.YEAR) acc.push(_types.DatePartEnum.YEAR);
    if (part === _types.DatePartEnum.MONTH) acc.push(_types.DatePartEnum.MONTH);
    if (part === _types.DatePartEnum.DATE) acc.push(_types.DatePartEnum.DATE);
    return acc;
  }, []);
  var formatString = getLocaleFormatString(order, separator);
  return {
    separator: separator,
    order: order,
    partsString: partsString,
    formatString: formatString,
    placeholderString: getLocalePlaceholderString(formatString, placeholder)
  };
};
/**
 * Converts date format information to format string. E.g. 'dd/mm/yyyy'.
 *
 * @param: datePartsOrder - The order the date parts are in for locale.
 * @param: separator - The locale separator.
 */


exports.getLocaleDateFormat = getLocaleDateFormat;

var getLocaleFormatString = function getLocaleFormatString(datePartsOrder, separator) {
  return datePartsOrder.map(function (datePart) {
    return _types.DatePartFormatMap[datePart];
  }).join(separator);
};
/**
 * Converts date format information to placeholder string, using provided placeholder character.
 * E.g. 'dd/mm/yyyy' -> '__/__/____'
 *
 * @param: datePartsOrder - The order the date parts are in for locale.
 * @param: separator - The locale separator.
 * @param: placeholder - The character to replace values with.
 */


exports.getLocaleFormatString = getLocaleFormatString;

var getLocalePlaceholderString = function getLocalePlaceholderString(dateFormatString, placeholder) {
  return dateFormatString.replace(/[A-Z|a-z]/g, placeholder);
};
/**
 * Gets the number of days in a month for a given month and year.
 *
 * @param month - The month to get days for. Will return 31 if month is not specified.
 * @param year - The year for getting the days of the month in. Default is current year.
 */


var getDaysInMonth = function getDaysInMonth(month, year) {
  if (month == null) return 31;
  return new Date(year || new Date().getFullYear(), month, 0).getDate();
};
/**
 * Custom hook that returns the current date.
 *
 * @param keepAliveDelay - The period in ms used for updating the date, 0 will cause the date to be static. Default = 0;
 */


exports.getDaysInMonth = getDaysInMonth;

var useCurrentDate = function useCurrentDate() {
  var keepAlivePeriod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _useState = (0, _react.useState)(new Date()),
      _useState2 = _slicedToArray(_useState, 2),
      date = _useState2[0],
      setDate = _useState2[1];

  (0, _react.useEffect)(function () {
    if (keepAlivePeriod) {
      var interval = setInterval(function () {
        return setDate(new Date());
      }, keepAlivePeriod);
      return clearInterval(interval);
    }
  }, [keepAlivePeriod]);
  return date;
};

exports.useCurrentDate = useCurrentDate;